export class admCatDocuments {
}